import PropTypes from 'prop-types';
import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';
import RoleBasedGuard from 'src/auth/guard/role-based-guard';

import { RouteGuard } from 'src/components/permissions';
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const ListUserPage = lazy(() => import('src/pages/medicore/users/list'));
const ListRolePermissionPage = lazy(() => import('src/pages/medicore/roles-permissions/list'));

// ----------------------------------------------------------------------

/**
 * Componente wrapper para proteger rutas de gestión de usuarios con permisos específicos
 * ⚠️ ULTRA-RESTRICTIVO: Solo master ve todo, otros usuarios solo lo que tienen permisos
 */
const ProtectedRoute = ({ route, children }) => (
  <RouteGuard route={route} fallbackRoute="/medicore" showFallback>
    <Suspense fallback={<LoadingScreen />}>{children}</Suspense>
  </RouteGuard>
);

ProtectedRoute.propTypes = {
  route: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

// ----------------------------------------------------------------------

export const medicoreUserManagementRoutes = [
  {
    path: 'medicore/userManagement',
    element: (
      <AuthGuard>
        <RoleBasedGuard roles={['admin', 'employee', 'superUser']}>
          <DashboardLayout>
            <Outlet />
          </DashboardLayout>
        </RoleBasedGuard>
      </AuthGuard>
    ),
    children: [
      {
        path: 'list',
        element: (
          <ProtectedRoute route="/medicore/userManagement/list">
            <ListUserPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'rolesPermissions',
        element: (
          <ProtectedRoute route="/medicore/userManagement/rolesPermissions">
            <ListRolePermissionPage />
          </ProtectedRoute>
        ),
      },
    ],
  },
];
